import React from 'react';
import { formatDate } from 'utils/dateFormater';
interface IModalCommon {
    handleClose?: () => void;
    versionsArr: any[];
    handleVersionChange: any;
    curVersion: any;
}
const ViewHistoryModal: React.FC<IModalCommon> = ({ handleClose, versionsArr, handleVersionChange, curVersion }) => {
  return (
    <div className='audit-modal-cont'>
      <div className='audit-modal-cont-head'>
        <div className='audit-modal-cont-head-content'>
          <div className='audit-modal-cont-head-content-text'>
            <h1>Version History</h1>
          </div>
        </div>
        <div className='audit-modal-cont-head-btn' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='view-history-head-frame'>
        <div className='view-history-head-frame-cell'>
          <div className='view-history-head-frame-cell-cont'>
            <div className='view-history-head-frame-cell-cont-text'>
                   Date Screened
            </div>
          </div>
        </div>
        <div className='view-history-head-frame-cell'>
          <div className='view-history-head-frame-cell-cont'>
            <div className='view-history-head-frame-cell-cont-text'>
              Total Results
            </div>
          </div>
        </div>
        <div className='view-history-head-frame-cell'>
          <div className='view-history-head-frame-cell-cont'>
            <div className='view-history-head-frame-cell-cont-text'>
              Results Added
            </div>
          </div>
        </div>
        <div className='view-history-head-frame-cell-empty'></div>
      </div>
      <div className='view-history-body-frame'>
        {versionsArr.map((ver, i) => (
          <div className='view-history-body-frame-row' key={ver._id}>
            <div className='view-history-body-frame-row-date'>
              <div className='view-history-body-frame-row-date-text'>{formatDate(ver.date)}</div>
            </div>
            <div className='view-history-body-frame-row-date'>
              <div className='view-history-body-frame-row-date-texts'>
                <div>{ver.allTotal}</div>
              </div>
            </div>
            <div className='view-history-body-frame-row-date'>
              <div className='view-history-body-frame-row-date-texts'>
                <div>{ver.newTotal}</div>
              </div>
            </div>
            {ver._id === curVersion._id ? <div className='view-history-body-frame-row-date'>
              <div className='view-history-body-frame-row-date-text'>Current</div>
            </div> : <div className='view-history-body-frame-row-date'>
              <div className='view-history-body-frame-row-date-text' style={{ cursor: 'pointer' }} onClick={() => handleVersionChange(ver)}>View</div>
            </div> }
          </div>
        ))}
      </div>
      <div className='audit-modal-cont-footer'>

      </div>
    </div>
  );
};

export default ViewHistoryModal;
